import React from "react";
import { useGlobalValue } from "../../state/GlobalProvider";
import styles from "./Widget.module.sass";
import Icon from "../Icon/Icon";
import SimpleButton from "../inputs/SimpleButton/SimpleButton";
const WidgetActions = props => {
  const {
    actions
  } = props;
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement("div", {
    className: styles["actions"]
  }, actions.filter(i => i).map(({
    onChange,
    onClick,
    value,
    type,
    icon,
    ref
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: styles["actions-item"]
  }, type === "file" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "file-upload",
    className: styles["file-input"]
  }, /*#__PURE__*/React.createElement("strong", null, i18n`Choose files`)), /*#__PURE__*/React.createElement("input", {
    id: "file-upload",
    ref: ref,
    type: "file",
    accept: "text/xml,application/zip,text/plain,application/pdf",
    multiple: true,
    onChange: onChange
  })) : /*#__PURE__*/React.createElement(SimpleButton, {
    className: `${styles["simple-button"]}`,
    onClick: onClick
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    name: "success",
    className: `${styles["icon"]}`
  }), value))));
};
export default WidgetActions;